//DUCKS pattern
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_MAP_SETTINGS, MapSettings } from 'app/components/dashboard/network/map/MapSettings';
import {
    DEFAULT_FULLSCREEN_MAP_SETTINGS,
    FullscreenMapSettings,
} from 'app/components/dashboard/network/FullscreenMapView';

//type of the state managed by the reducer
interface MapDataState {
    mapSettings: MapSettings;
    fullscreenMapSettings: FullscreenMapSettings;
}

const initialState: MapDataState = {
    //empty
    mapSettings: DEFAULT_MAP_SETTINGS,
    fullscreenMapSettings: DEFAULT_FULLSCREEN_MAP_SETTINGS,
};

const mapSettingsDataSlice = createSlice({
    name: 'mapSettingsData', // string that will be used as the prefix for generated action types
    initialState,
    reducers: {
        setMapSettings(state: MapDataState, action: PayloadAction<MapSettings>) {
            state.mapSettings = action.payload;
        },
        setFullscreenMapSettings(state: MapDataState, action: PayloadAction<FullscreenMapSettings>) {
            state.fullscreenMapSettings = action.payload;
        },
    },
    extraReducers(builder) {},
});

export const { setMapSettings, setFullscreenMapSettings } = mapSettingsDataSlice.actions;
export default mapSettingsDataSlice.reducer;
